// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1eSCS","head":"ProcedureTableInfo_head__3MwzW"};